import { render, staticRenderFns } from "./SubscriptionHeaderRecipients.vue?vue&type=template&id=02378f26&scoped=true&"
import script from "./SubscriptionHeaderRecipients.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionHeaderRecipients.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionHeaderRecipients.vue?vue&type=style&index=0&id=02378f26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02378f26",
  null
  
)

export default component.exports